<template>
  <BasicContainer>
    <div class="container" v-if="flag">
      <QrCode :qrCode="infomation.qrcode" v-if="!isQrCode"></QrCode>
      <StorePicking
        :expectProductCategories="infomation.expectProductCategories"
        :pickProductQuantity="infomation.pickProductQuantity"
        :sendProductQuantity="infomation.sendProductQuantity"
      ></StorePicking>
      <div class="line">
        <div class="ico"></div>
      </div>
      <SendBill
        class="sendBill"
        v-for="(item, index) in infomation.receipts"
        :key="index"
        :productInfo="item"
      ></SendBill>
    </div>
  </BasicContainer>
</template>

<script>
import QrCode from "./qrCode";
import StorePicking from "./storePicking";
import SendBill from "./sendBill";
import { getPickList } from "@/api/exportPDF";
import { downBlobFile } from "@/util/downloadFile";
export default {
  components: { QrCode, StorePicking, SendBill },
  data() {
    return {
      infomation: {},
      flag: false,
      isQrCode: "",
      PDFList: [],
      sn: "",
    };
  },
  created() {
    const sn = window.location.search.split("?")[1].split("&")[1].split("=")[1];
    this.sn = sn;
    console.log(this.isQrCode, "空");
    const qrcode = window.location.search
      .split("?")[1]
      .split("&")[0]
      .split("=")[1];
    if (qrcode == "false") {
      this.isQrCode = false;
    } else {
      this.isQrCode = true;
    }
    getPickList(sn).then((res) => {
      this.infomation = res.data.data;
      this.flag = true;
    });
  },
  mounted() {},

  methods: {
    download() {
      downBlobFile(
        "/shipment/app/send/pdfDownload",
        { sn: this.sn, actionType: "SEND" },
        `拣货单${this.sn}.pdf`
      );
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  margin: 40px !important;
  .line {
    width: 750px;
    height: 0;
    border-top: 1px dashed rgba(0, 0, 0, 0.4);
    margin-left: -40px;
    margin-top: 64px;
    margin-bottom: 65px;
    position: relative;
    .ico {
      width: 48px;
      height: 48px;
      background: url("../../assets/logisticsPDF/cut.webp") no-repeat;
      background-size: 100%;
      position: absolute;
      top: -25px;
    }
  }
  .btn {
    width: 750px;
    height: 98px;
    background: linear-gradient(90deg, #facc6e 0%, #f87b2b 100%);
    border-radius: 16px 16px 0px 0px;
    margin-left: -40px;
    margin-top: 40px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 32px;
  }
  .sendBill {
    margin-bottom: 40px;
  }
}
</style>
